import { useEffect } from 'react';
import { Form, Input, Modal, Select } from 'antd';
import { useDeleteParentFosterCareMutation } from '@/services/parent-api';

const options = [
  { value: 'Voluntarily Withdrawn', label: 'Voluntarily Withdrawn' },
  { value: 'DCS Revocation', label: 'DCS Revocation' },
  { value: 'Other', label: 'Other' },
];

const RemoveModal = ({ parentId, open, refetch, refetchHasLicense, setShouldRemoveRefetch, onClose }) => {
  const [deleteFosterCare, { isLoading }] = useDeleteParentFosterCareMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async ({ reason, other = '' }) => {
    try {
      await deleteFosterCare({
        parentId,
        body: {
          note: reason === 'Other' ? `Other: ${other}` : reason,
        },
      }).unwrap();
      refetch();
      refetchHasLicense();
      onClose();
      setShouldRemoveRefetch(true);
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title="Remove License"
        open={open}
        okText="Remove"
        confirmLoading={isLoading}
        onOk={() => form.submit()}
        onCancel={onClose}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item name="reason" label="Reason" style={{ marginBottom: 12 }}>
            <Select options={options} />
          </Form.Item>

          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.reason !== currentValues.reason}>
            {({ getFieldValue }) =>
              getFieldValue('reason') === 'Other' && (
                <Form.Item name="other" style={{ marginBottom: 0 }}>
                  <Input.TextArea autoSize={{ minRows: 3 }} />
                </Form.Item>
              )
            }
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default RemoveModal;
